<app-textarea-field
  [label]="'LABEL.COMMENT' | translate"
  fieldId="note_field"
  textareaE2eId="add-note-field"
  toggleActionE2eId="add-note-field-toggle-action"
  [placeholder]="'PLACEHOLDER.ENTER_COMMENT_FOR_CUSTOMER' | translate"
  [fieldControl]="formControl"
  [hideFieldIfNoInitialValue]="true"
  [fieldTriggerLabel]="'ACTION.ADD_COMMENT' | translate"
  (onBlur)="updateNote()"
  [maxlength]="4000"
  [trackingObject]="trackingObject"
  [triggerTrackingAction]="trackingAction"
>
</app-textarea-field>
